import type { QuestionModule } from "../contracts";
import {
  ratingCore,
  type RatingDefinition,
  type RatingDraft,
  type RatingEvent,
  type RatingRaw,
  type RatingResponse,
} from "./core";
import { RatingButtonsView, RatingSliderView, RatingStarsView } from "./views";

export const ratingModule: QuestionModule<
  RatingRaw,
  RatingDefinition,
  RatingDraft,
  RatingEvent,
  RatingResponse
> = {
  type: "rating",
  galleryFeatures: [
    "baseline",
    "labels",
    "images",
    "restored",
    "dont-know",
    "unanswered",
    "non-one-based",
  ],
  core: ratingCore,
  resolveSpace: (definition) =>
    definition.options.length >= 8 ? "expanded" : undefined,
  prompt: (definition) => ({
    content: definition.prompt,
    image: definition.image,
    altText: definition.altText,
    error: definition.error,
  }),
  views: {
    buttons: {
      id: "buttons",
      label: "Buttons",
      component: RatingButtonsView,
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
    slider: {
      id: "slider",
      label: "Slider",
      component: RatingSliderView,
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
    star: {
      id: "star",
      label: "Stars",
      component: RatingStarsView,
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
  },
  defaultDisplay: { view: "slider" },
  resolveDisplay: (raw) => ({
    view: raw.style === "button" ? "buttons" : raw.style,
  }),
  controls: (_definition, _draft, _display, copy) => ({
    primaryAction: {
      purpose: "submit",
      label: copy.actions.send,
      action: { type: "submit" },
    },
  }),
};
